import { Banknote, CreditCard, Landmark, Nfc, User, Vault } from 'lucide-react';

import type { LucideIcon } from 'lucide-react';

export const KIND_ICONS: Record<string, LucideIcon> = {
  cash: Banknote,
  cashless: Nfc,
  safe: Vault,
  personal: User,
  bank: Landmark,
  card_account: CreditCard,
};

export const KIND_LABEL_KEYS: Record<string, string> = {
  cash: 'Cash',
  cashless: 'Cashless',
  safe: 'Safe',
  personal: 'Personal',
  bank: 'Bank',
  card_account: 'Card Account',
};

export const GREY_LEGAL_ENTITY_LABEL_KEY = 'Grey (no legal entity)';
